<template>
	<div class="tab-content">
		<form class="login-form" @submit.prevent="$emit('login', loginForm)">
			<div class="form-group">
				<label class="form-label">手机号码</label>
				<div class="input-group">
					<input type="tel" class="form-input" placeholder="请输入手机号码" v-model="loginForm.phone" required
						@input="validatePhone">
					<i class="el-icon-phone input-icon"></i>
				</div>
				<div class="error-message" v-if="errors.phone">{{ errors.phone }}</div>
			</div>

			<div class="form-group">
				<label class="form-label">登录密码</label>
				<div class="input-group">
					<input type="password" class="form-input" placeholder="请输入登录密码" v-model="loginForm.password"
						required @input="validatePassword">
					<i class="el-icon-lock input-icon"></i>
				</div>
				<div class="error-message" v-if="errors.password">{{ errors.password }}</div>
			</div>

			<div class="form-options">
				<a href="#" class="forgot-password" @click.prevent="$emit('show-forgot-password')">
					忘记密码？
				</a>
			</div>

			<button type="submit" class="btn btn-primary" :disabled="!isFormValid || loading">
				<span v-if="loading" class="loading-spinner"></span>
				{{ loading ? '登录中...' : '立即登录' }}
			</button>
		</form>
	</div>
</template>

<script>
	export default {
		name: 'LoginForm',
		props: {
			loading: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				loginForm: {
					phone: '',
					password: ''
				},
				errors: {
					phone: '',
					password: ''
				}
			}
		},
		computed: {
			isFormValid() {
				return (
					this.loginForm.phone &&
					this.loginForm.password &&
					!this.errors.phone &&
					!this.errors.password
				)
			}
		},
		methods: {
			validatePhone() {
				const phoneRegex = /^1[3-9]\d{9}$/
				if (!this.loginForm.phone) {
					this.errors.phone = '请输入手机号码'
				} else if (!phoneRegex.test(this.loginForm.phone)) {
					this.errors.phone = '手机号码格式不正确'
				} else {
					this.errors.phone = ''
				}
			},
			validatePassword() {
				if (!this.loginForm.password) {
					this.errors.password = '请输入密码'
				} else if (this.loginForm.password.length < 6) {
					this.errors.password = '密码长度至少6位'
				} else {
					this.errors.password = ''
				}
			},
			resetForm() {
				this.loginForm = {
					phone: '',
					password: ''
				}
				this.errors = {
					phone: '',
					password: ''
				}
			}
		},
		watch: {
			loading(newVal) {
				if (!newVal) {
					// 可以根据需要在这里重置表单
				}
			}
		}
	}
</script>

<style scoped>
	/* 保留原有的样式，或者可以从父组件继承 */
	.form-group {
		margin-bottom: 16px;
	}

	.form-label {
		display: block;
		margin-bottom: 6px;
		font-size: 13px;
		color: #666;
		font-weight: 500;
	}

	.input-group {
		position: relative;
	}

	.form-input {
		width: 100%;
		padding: 12px 14px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		font-size: 14px;
		color: #333;
		transition: all 0.3s ease;
		background: #fafafa;
	}

	.form-input:focus {
		outline: none;
		border-color: #2280FD;
		background: white;
		box-shadow: 0 0 0 3px rgba(34, 128, 253, 0.1);
	}

	.input-icon {
		position: absolute;
		right: 14px;
		top: 50%;
		transform: translateY(-50%);
		color: #999;
		font-size: 14px;
	}

	.error-message {
		color: #ff4d4f;
		font-size: 12px;
		margin-top: 4px;
		height: 16px;
	}

	.form-options {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-bottom: 20px;
	}

	.forgot-password {
		color: #2280FD;
		text-decoration: none;
		font-size: 13px;
		transition: color 0.3s ease;
	}

	.forgot-password:hover {
		color: #1a6fd0;
	}

	.btn {
		width: 100%;
		padding: 12px;
		border: none;
		border-radius: 8px;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		position: relative;
	}

	.btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
		transform: none !important;
		box-shadow: none !important;
	}

	.btn-primary {
		background: #2280FD;
		color: white;
		box-shadow: 0 3px 10px rgba(34, 128, 253, 0.3);
	}

	.btn-primary:hover:not(:disabled) {
		background: #1a6fd0;
		transform: translateY(-1px);
		box-shadow: 0 5px 15px rgba(34, 128, 253, 0.4);
	}

	.btn-primary:active:not(:disabled) {
		transform: translateY(0);
	}

	.loading-spinner {
		width: 16px;
		height: 16px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-radius: 50%;
		border-top-color: white;
		animation: spin 1s ease-in-out infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
</style>